import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-loading-skeleton',
    templateUrl: './loading-skeleton.component.html',
    styleUrls: ['./loading-skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class LoadingSkeletonComponent {

  @Input() type: 'card' | 'table' = 'card'
  @Input() count: number = 1;

  placeHolderData = ['ID', 'Beginn Veröff.', 'Ende Veröff.', 'Status', 'Workflow', 'Bearbeiten', 'Mehr'];
  placeHolderDataContent = [{width: '120px'}, {width: '50px'}, {width: '50px'}, {width: '70px'}, {width: '70px'}, {width: '30px'}, {width: '50px'}];

  public getArrayFromNumber() {
    return new Array(this.count);
  }

}
